import {
  GET_EVENT_REASONS,
} from 'constants/eventReasons';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_EVENT_REASONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
